Object.assign(module.exports, require("@storybook/addon-links"))
// Remove the default shim pointing to the react module
// ours is in blocks
delete module.exports.LinkTo

module.exports.reduxEnhancer = require("addon-redux/enhancer").default

module.exports.makeDecorator = require("@storybook/addons").makeDecorator
